import React from "react";

const Currency = ({ number }) => (
  <span className="currency">
    {new Number(number).toFixed(2).replace(".00", "")} лв.
  </span>
);

export default Currency;
